module.exports = __webpack_public_path__ + "media/images/articles/job_motivation/img01-b1965c9d0b4f8d103e1b38e7576b5ed2.png";